<template>
  <th>{{ label }}</th>
</template>
<script>
  /**
  * 排行Table column
  */
  export default {
    name: 'zycChartsTableColumn',
    props: {
      label: {
        type: String,
        default:''
      }
    },
    model: {
    },
    watch: {
    },
    data() {
      return {
      }
    },
    mounted() {
      
    },
    created() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/table/chartsTableColumn.vue